export default "__VITE_ASSET__DmzD1YeT__"